import { queryClient, useMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { Banner, CreateBannerRequest, GetBannersResponse } from '../../../../shared/types/routes/banners';

import { bannersQueryKey } from './useBanners';

const createBanner = (banner: CreateBannerRequest) =>
  post<CreateBannerRequest, Banner>('/api/banners', banner);

/**
 * Hook for creating a new banner.
 */
export default function useCreateBanner() {
  return useMutation<CreateBannerRequest, Response & { data?: Banner }>({
    mutationFn: createBanner,
    onSuccess: (response: Response & { data?: Banner }) => {
      const banner = response?.data ?? null;
      if (banner) {
        //  Update the banners query cache
        queryClient.setQueryData<GetBannersResponse>(bannersQueryKey, (banners?: GetBannersResponse) => {
          return (banners ? [...banners, banner] : [banner]) as GetBannersResponse;
        });
      }
    },
  });
}
